<template>
  <ul class="w-full text-gray-900 bg-white rounded-lg border border-gray-200 ">
    <li class="flex py-4 px-4 w-full rounded-t-lg border-b border-gray-200 hover:text-gray-700 hover:bg-gray-100"
        v-for="(item,index) in ItemList" :key="index">
      <i class="pi pi-chevron-right"></i> <span class="ml-2">{{ item }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "UnorderedList",
  props: {
    ItemList: Array
  }

}
</script>

<style scoped>

</style>
